import { cx } from '@linaria/core';
import { Link as Link$1 } from '@provider/navigation';
import { resets } from '@ui/css';
import { Chevron } from '@utils/react';
import { themeIcon, secondaryThemeChevron, link, modifiers } from './link.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Link({
  theme,
  icon,
  ...props
}) {
  return /*#__PURE__*/jsxs(Link$1, {
    ...props,
    ref: props.ref,
    className: cx(resets.rootCls, link, props.className, !!icon && modifiers.withIcon.className),
    "data-theme": theme,
    children: [theme === "primary" && icon && /*#__PURE__*/jsx("span", {
      className: themeIcon,
      children: icon
    }), theme === "secondary" && /*#__PURE__*/jsx("span", {
      className: secondaryThemeChevron,
      children: /*#__PURE__*/jsx(Chevron, {
        size: 6,
        lineWidth: 1.5
      })
    }), props.children, theme === "tertiary" && /*#__PURE__*/jsx(Chevron, {
      size: 9,
      lineWidth: 1.5
    }), theme === "secondary" && icon && /*#__PURE__*/jsx("span", {
      className: themeIcon,
      children: icon
    })]
  });
}
function LinkButton({
  theme,
  icon,
  ...props
}) {
  return /*#__PURE__*/jsxs("button", {
    ...props,
    ref: props.ref,
    className: cx(resets.rootCls, link, props.className, !!icon && modifiers.withIcon.className),
    "data-theme": theme,
    children: [theme === "primary" && icon && /*#__PURE__*/jsx("div", {
      className: themeIcon,
      children: icon
    }), theme === "secondary" && /*#__PURE__*/jsx("div", {
      className: secondaryThemeChevron,
      children: /*#__PURE__*/jsx(Chevron, {
        size: 6,
        lineWidth: 1.5
      })
    }), /*#__PURE__*/jsx("span", {
      children: props.children
    }), theme === "tertiary" && /*#__PURE__*/jsx(Chevron, {
      size: 9,
      lineWidth: 1.5
    }), theme === "secondary" && icon && /*#__PURE__*/jsx("div", {
      className: themeIcon,
      children: icon
    })]
  });
}

export { Link, LinkButton };
//# sourceMappingURL=link.js.map
